import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { verifiedAadharQRDataHelperAPI } from "../helpers/VerifiedDocAPI";


const initialState = {
    getVerifiedData: null,
    loading: false,
    error: null,
    encryptedId: null,
}

export const getVerifiedDocDataReducer = createAsyncThunk('verifiedDoc/get-verified-doc-data', async (payload, thunkAPI) => {
    try {
        const response = await verifiedAadharQRDataHelperAPI(payload);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

const VerifiedDocSlice = createSlice({
    name: 'VerifiedDoc',
    initialState,
    reducers: {
        clearProfileState: (state) => {
            state.getVerifiedData = null;
            state.loading = false;
            state.error = null;
            state.encryptedId = null;

        },
        setEncryptedId: (state, action) => {
            state.encryptedId = action?.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getVerifiedDocDataReducer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getVerifiedDocDataReducer.fulfilled, (state, action) => {
                state.getVerifiedData = action.payload;
                state.loading = false;
                // console.log("Verified data", JSON.stringify(action));
                // state.error = null;
            })
            .addCase(getVerifiedDocDataReducer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
          
    },
});

export const { clearProfileState, setEncryptedId } = VerifiedDocSlice.actions;

export default VerifiedDocSlice.reducer;
